import { render, staticRenderFns } from "./CategoryAutocompleteMultiple.vue?vue&type=template&id=e08f9bc8&scoped=true&"
import script from "./CategoryAutocompleteMultiple.vue?vue&type=script&lang=js&"
export * from "./CategoryAutocompleteMultiple.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAutocompleteMultiple.vue?vue&type=style&index=0&id=e08f9bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08f9bc8",
  null
  
)

export default component.exports